import { axios } from "@/plugins/http-request.js";

const actions = {
  getomsMapping(context, payload) {
    return axios
      .get(`/api/oms-client-mapping/${payload.client_id}`, {
        params: payload.params,
      })
      .then((res) => res.data);
  },
  getVendorList() {
    return axios.get(`/api/oms-vendor-list`).then((res) => res.data);
  },
  getInforVendorList() {
    return axios
      .get(`/api/oms-vendor-list?vendor_type=INFOR`)
      .then((res) => res.data);
  },
  getInforWarehouseList() {
    return axios
      .get(`/api/fulfillmentbb/infor_warehouse/list`)
      .then((res) => res.data);
  },
  getInforWarehouseListBB(_, id) {
    return axios
      .get(`/api/fulfillmentbb/infor_warehouse/list?client_id=${id}`)
      .then((res) => res.data);
  },
  getInforWarehouseListBBInfor(_, payload) {
    return axios
      .get(`/api/fulfillmentbb/infor_warehouse/list`, {
        params: payload,
      })
      .then((res) => res.data);
  },

  getInforStoreList() {
    return axios
      .get(`/api/fulfillmentbb/infor_storer/list`)
      .then((res) => res.data);
  },
  getinboundvariantDetails(_, id) {
    return axios
      .get(`/api/btb_inbound_variant/edit/${id}`)
      .then((res) => res.data);
  },
  getfecalityData() {
    return axios
      .get(`/api/fulfillment/oms-facility/list`)
      .then((res) => res.data);
  },
  mappingSync(_, id) {
    return axios
      .get(`/api/fulfillment/oms_facility_sync?client_id=${id}`)
      .then((res) => res.data);
  },
  createMapping(context, payload) {
    return axios
      .post("/api/oms-client-mapping", payload.params)
      .then((res) => res.data);
  },
  updateOMSmapping(context, payload) {
    return axios
      .patch(
        `/api/oms-client-mapping-change-status/${payload.id}`,
        payload.data
      )
      .then((res) => res.data);
  },
  createFacility(context, payload) {
    return axios
      .post("/api/oms-facility-check?format=json", payload.params)
      .then((res) => res.data);
  },
};

export default {
  actions,
};
